import React from "react";

function ChevronRightIcon() {
  return (
    <svg data-testid="ChevronRightIcon" viewBox="0 0 24 24">
      <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
    </svg>
  );
}

export default React.memo(ChevronRightIcon);
